import { render } from "./Main.vue?vue&type=template&id=d6dcf742&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=d6dcf742&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6dcf742"]])

export default __exports__